import { CountUp } from 'countup.js'
import MediaQuery from '../../../../Arrk.NodeTypes/Resources/Private/JavaScript/Modules/MediaQuery'

class Counter {
    constructor(counterNumber) {
        this.counterNumber = counterNumber
        this.counterData = counterNumber.dataset
        this.counter = counterNumber.closest('.counter')
        this.counterWrapperData = counterNumber.closest('.counters').dataset
        this.init()
        this.addScrollIntoViewObserver()
    }

    /**
     * @private
     */
    init() {
        const endValue = this.counterData.endVal

        let decimalPlaces = 0
        // If there is a decimal point the resulting array is bigger than one
        if (endValue.split('.').length > 1) {
            decimalPlaces = endValue.split('.')[1].length
        }

        const options = {
            duration: this.counterWrapperData.duration,
            useGrouping: false,
            decimalPlaces: decimalPlaces,
            prefix: this.counterData.prefix,
            suffix: this.counterData.suffix,
        }

        this.countUp = new CountUp(this.counterNumber, parseFloat(endValue), options)
    }

    /**
     * @private
     */
    addScrollIntoViewObserver() {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.counter.classList.add('animate')
                        let delay = 0
                        if (MediaQuery.UpMd.matches) {
                            delay = 1000 * this.counterData.delay
                        }
                        setTimeout(() => {
                            this.countUp.start()
                            observer.unobserve(entry.target)
                        }, delay)
                    }
                })
            },
            { rootMargin: '0px 0px -50px 0px' }
        )
        observer.observe(this.counterNumber)
    }
}

function initCounters() {
    const counters = document.querySelectorAll('.counter__number')

    counters.forEach((counter) => {
        new Counter(counter)
    })
}

if (document.readyState !== 'loading') {
    initCounters()
} else {
    document.addEventListener('DOMContentLoaded', initCounters)
}
